import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../apiConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";

const Menu = () => {
  const navigate = useNavigate();
  const lider = localStorage.getItem("lider");
  const [participantes, setParticipantes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [paginaActual, setPaginaActual] = useState(1);
  const [imagenSeleccionada, setImagenSeleccionada] = useState(null); //  Nuevo estado para la imagen
  const participantesPorPagina = 3;
  const totalPaginas = Math.ceil(participantes.length / participantesPorPagina);
  const indiceInicial = (paginaActual - 1) * participantesPorPagina;
  const indiceFinal = indiceInicial + participantesPorPagina;
  const participantesMostrados = participantes.slice(indiceInicial, indiceFinal);

  const handleLogout = () => {
    console.log(" Cerrando sesión...");
    localStorage.removeItem("lider");
    localStorage.removeItem("liderId");
    navigate("/");
  };

  const fetchParticipantes = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Lider/GetParticipantes`, {
            params: { usuario: lider },
        });

        const participantesConINE = await Promise.all(response.data.map(async (p) => {
            try {
                const ineResponse = await axios.get(`${API_BASE_URL}/Lider/ObtenerINE`, {
                    params: { telefono: p.whatsApp },
                });

                return { ...p, ineImagen: ineResponse.data.ineUrl };
            } catch (error) {
                console.warn(`No hay imagen de INE para: ${p.nombres}`);
                return { ...p, ineImagen: null }; // Si no tiene INE, asignamos `null`
            }
        }));

        console.log("📢 Participantes con INE:", participantesConINE);
        setParticipantes(participantesConINE);
        setShowModal(true);
    } catch (error) {
        toast.error("No tienes participantes.", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        style: {
          backgroundColor: "#D32F2F",
          color: "#ffffff",
          borderRadius: "8px",
        },
      });

    }
};


  const handleEliminarParticipante = async (telefono) => {
    const confirmacion = await Swal.fire({
        //title: '¿Estás seguro?',
        title: "¿Estás seguro de que deseas eliminar este participante?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        background: '#081b29', // Color de fondo oscuro
        color: '#ffffff', // Color del texto blanco para mayor contraste
      });
      // Verifica si la acción fue confirmada
  if (!confirmacion.isConfirmed) return;

  try {
    const response = await axios.post(
      `${API_BASE_URL}/Lider/EliminarParticipante`,
      JSON.stringify({ telefono }),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    Swal.fire({
      title: 'Eliminado!',
      text: response.data.message,
      icon: 'success',
      confirmButtonColor: '#3085d6',
      background: '#081b29', // Color de fondo oscuro
      color: '#ffffff' // Color del texto blanco
    });

    // Actualiza la lista de participantes si la eliminación fue exitosa
    setParticipantes(participantes.filter((p) => p.whatsApp !== telefono));
  } catch (error) {
    console.error("Error al eliminar participante:", error);
    Swal.fire({
      title: 'Error',
      text: 'Hubo un error al eliminar el participante.',
      icon: 'error',
      confirmButtonColor: '#d33',
      background: '#081b29', // Color de fondo oscuro
      color: '#ffffff' // Color del texto blanco
    });
  }
};

  //  Mostrar la imagen de INE en un modal
  const verImagenINE = (imagenUrl) => {
    setImagenSeleccionada(imagenUrl);
  };

  return (
    <div className="wrapper">
      <div className="form-box">
        <img src="/img/monytorlogoa.png" alt="Imagen de login" className="login-image" />
        <h2>Bienvenido</h2>

        <div className="flex flex-col gap-3">
          <button className="btn" onClick={() => navigate("/registroParticipantes")}>
            Registrar Participante
          </button>
          <button className="btn" onClick={fetchParticipantes}>
            Ver Participantes
          </button>
          <button className="btn btn-primary" onClick={() => navigate("/eventosParticipantes")}>
            Mis Eventos
          </button>
          <button className="btn" onClick={handleLogout}>
            Cerrar Sesión
          </button>
        </div>
      </div>

      {showModal && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div
          className="bg-[#081b29] p-6 rounded-lg shadow-lg max-w-lg w-full relative text-white  max-h-screen overflow-y-auto"
          //onClick={(e) => e.stopPropagation()}
        >
          <div className="flex justify-between items-center border-b pb-2">
            <h3 className="text-lg font-semibold text-white flex items-center">
              <img src="/img/logoazul.png" alt="Icono" className="w-6 h-6 mr-2" />
              Lista de Participantes
            </h3>
            {/*  Contador de Participantes */}
              <h4 className="text-white px-4 py-2 rounded-lg bg-[#0f283a]">
                Participantes: {participantes.length}
              </h4>
            <button
              onClick={() => setShowModal(false)}
              className="text-gray-600 hover:text-white text-lg"
            >
              ✖
            </button>
          </div>

          {/*  Total de Participantes
          <h4 className="mt-3 text-white px-4 py-2 rounded-lg inline-block">
            Total de participantes: {participantes.length}
          </h4>
          */}

          {/*  Contenido con paginación */}
          <div className="mt-4">
            {participantes.length > 0 ? (
              <>
                <ul className="list-none pl-0 space-y-4">
                  {participantesMostrados.map((p, index) => (
                    <li key={index} className="flex flex-col border-b pb-2">
                      <div className="mb-2">
                        <strong>{p.nombres} {p.apellidos}</strong> <br />
                        <small>WhatsApp: {p.whatsApp}</small> <br />
                        <small>Registrado el: {p.fechaRegistro}</small>
                      </div>
                      <div className="flex gap-2">
                        {/* Si tiene INE, mostrar botón */}
                        {p.ineImagen && (
                          <button
                            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 transition"
                            onClick={() => verImagenINE(p.ineImagen)}
                          >
                            Ver INE
                          </button>
                        )}
                        <button
                          className="bg-red-500 text-black px-3 py-1 rounded hover:bg-red-600 transition"
                          onClick={() => handleEliminarParticipante(p.whatsApp)}
                        >
                          Eliminar
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>

                {/*  Paginación */}
                <div className="flex justify-center mt-4 gap-2">
                  <button
                    className={`px-3 py-1 rounded ${
                      paginaActual === 1 ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
                    }`}
                    onClick={() => setPaginaActual(paginaActual - 1)}
                    disabled={paginaActual === 1}
                  >
                    ◀ Anterior
                  </button>
                  {[...Array(totalPaginas)].map((_, index) => (
                    <button
                      key={index}
                      className={`px-3 py-1 rounded ${
                        paginaActual === index + 1 ? "bg-blue-600 text-white" : "bg-gray-500 hover:bg-gray-600"
                      }`}
                      onClick={() => setPaginaActual(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    className={`px-3 py-1 rounded ${
                      paginaActual === totalPaginas ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
                    }`}
                    onClick={() => setPaginaActual(paginaActual + 1)}
                    disabled={paginaActual === totalPaginas}
                  >
                    Siguiente ▶
                  </button>
                </div>
              </>
            ) : (
              <p className="text-gray-600 text-center">No hay participantes registrados.</p>
            )}
          </div>

          <div className="mt-6 flex justify-end gap-2">
            <button
              className="bg-gray-500 text-black px-4 py-2 rounded hover:bg-gray-600 transition"
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    )}


      {/*  MODAL PARA VER IMAGEN DE INE */}
      {imagenSeleccionada && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75"
          //onClick={() => setImagenSeleccionada(null)}
        >
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full text-black relative"
              onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center border-b pb-2">
              <h3 className="text-lg font-semibold">Imagen de INE</h3>
              <button
                onClick={() => setImagenSeleccionada(null)}
                className="text-gray-600 hover:text-black text-lg"
              >
                ✖
              </button>
            </div>
            <div className="mt-4 flex justify-center">
              <img src={imagenSeleccionada} alt="INE" className="max-w-full h-auto rounded-lg" />
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Menu;
